(function initSubmissionCache() {
  const LOCAL_STORAGE_KEY = 'submissionCache';
  const submissionCache = {};
  const submissionPromises = {};

  const readFromStorage = (dogId) => {
    try {
      const storedCache = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
      return storedCache[dogId];
    } catch (error) {
      return null;
    }
  };

  const writeToStorage = (dogId, submission) => {
    try {
      const storedCache = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
      storedCache[dogId] = submission;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedCache));
    } catch (error) {
      // Swallow storage errors to avoid interrupting flow
    }
  };

  function loadSubmissionWithCache({ dogId, onLoaded } = {}) {
    const callback = () => {
      const cachedSubmission = submissionCache[dogId];

      if (cachedSubmission && typeof onLoaded === 'function') {
        onLoaded(cachedSubmission);
      }
    };

    if (!dogId) {
      return callback;
    }

    const hasInMemoryCache = Boolean(submissionCache[dogId]);

    if (!submissionPromises[dogId]) {
      submissionPromises[dogId] = fetchSubmissionRequest({ dogId })
        .then((response) => response.json())
        .then((data) => {
          submissionCache[dogId] = data;
          writeToStorage(dogId, data);
          return data;
        });
    }

    if (!hasInMemoryCache) {
      const locallyCachedSubmission = readFromStorage(dogId);

      if (locallyCachedSubmission) {
        console.log("Found submission in cache!");
        submissionCache[dogId] = locallyCachedSubmission;
        callback();
      }

      submissionPromises[dogId].then(() => callback());

      return callback;
    }

    callback();
    submissionPromises[dogId].then(() => callback());

    return callback;
  }

  window.loadSubmissionWithCache = loadSubmissionWithCache;
})();
